export default {"src":"/_next/static/media/dashboardIcon.c8ee82fa.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};